import { css } from "emotion";

import { colors } from "@cobliteam/base-components/src/styles";

export const contentBox = css`
  display: flex;
  flex-direction: row;
  padding: 20px;
  margin-top: 20px;
  box-sizing: border-box;
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;
  background: ${colors.custom.lightestGray50};
`;
